var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-block btn-social btn-line",on:{"click":_vm.login}},[_c('span',{staticClass:"fa fa-line"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.loginText)}})]),(_vm.error)?_c('span',{staticStyle:{"color":"#dc3545","font-size":"80%"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }